export const ownerAdjustmentsModalId = 'create-owner-adjustments-modal';
